import { LoadingOverlay, Box, Group, Button, Switch } from '@mantine/core';

import { useConfigSms } from '../hooks/use-config-sms';

export const Sms = () => {
  const {
    form,
    isLoading,
    handleSubmit,
  } = useConfigSms();

  return (
    <Box style={{ position: 'relative' }}>
      <LoadingOverlay
        visible={isLoading}
        overlayProps={{ blur: 2 }}
      />

      <form onSubmit={form.onSubmit(handleSubmit)}>
        <Switch
          label="Верификация по SMS"
          key={form.key('enabled')}
          {...form.getInputProps('enabled', { type: 'checkbox' })}
        />

        <Group justify="flex-start" mt="30">
          <Button type="submit" loading={isLoading}>
            Сохранить
          </Button>
        </Group>
      </form>
    </Box>
  );
};
